class Currency {
    constructor(data) {
        this.id = data.id || null;
        this.code = data.code || null;
        this.name = data.name || null;
        this.sign = data.sign || null;
        this.country_code = data.country_code || null;
        this.image = data.image || null;
        this.sort = data.sort || 0;
        this.titles = data.titles || {
            ru: data.titles?.ru || data.name,
            en: data.titles?.en || data.name
        }
    }

    toObject() {
        return {
            id: this.id,
            code: this.code,
            name: this.name,
            sign: this.sign,
            country_code: this.country_code,
            image: this.image,
            sort: this.sort,
            titles: this.titles
        }
    }
}

class CurrencyList {
    constructor(list) {
        this.items = (list || []).map(item => new Currency(item))
    }

    // Получение списка из Vuex стора
    static GetListFromStore(store) {
        if(!store) return []
        if(!(store instanceof Object)) return []
        return store.getters.GetCurrencies || []
    }

    // Получение данных с API
    static async FetchFromApi(store) {
        const res = await store.dispatch('GetCurrencies')
        if (res && res.data && Array.isArray(res.data)) {
            const arr = res.data.map(item => (item instanceof Currency ? item.toObject() : new Currency(item).toObject()))
            store.commit('setCurrencies', arr)
            return arr
        }
        return []
    }

    // Получение списка с проверкой в сторе и запросом к API
    static async GetList(store) {
        let list = this.GetListFromStore(store)
        if (!list || !list.length) {
            list = await this.FetchFromApi(store)
        }
        return list
    }

    static GetFilteredCurrencies(filteredRates, currencySend, direction, store) {
        if(!filteredRates || !currencySend) return []
        if(!direction || (direction!='get' && direction!=='send')) return []
        if(!store) return []
        let currencies = []

        const arrCurrencyList = this.GetListFromStore(store)
        if(!arrCurrencyList || !arrCurrencyList.length) return []

        const arrCurrencies = this.ToObjectMap(arrCurrencyList)

        let codes = new Set()
        for (let i = 0; i < filteredRates.length; i++) {
            if(direction === 'get' && filteredRates[i].from_currency_code == currencySend.code) {
                const cur = arrCurrencies[filteredRates[i].to_currency_code]
                if(cur && cur.code && cur.code != currencySend.code) codes.add(cur.code)
            } else if(direction === 'send' && filteredRates[i].to_currency_code == currencySend.code) {
                const cur = arrCurrencies[filteredRates[i].from_currency_code]
                if(cur && cur.code && cur.code != currencySend.code) codes.add(cur.code)
            }
        }
        currencies = Array.from(codes).map(code => arrCurrencies[code]).filter(Boolean)
        currencies.sort((a, b) => {
            const valA = a.sort !== undefined ? a.sort : 9999
            const valB = b.sort !== undefined ? b.sort : 9999
            return valA - valB
        })
        return currencies
    }

    // Преобразование в простой объект с кодами валют в ключах
    static ToObjectMap(list) {
        if (!list || !Array.isArray(list)) return {}
        const obj = {}
        list.forEach(item => {
            if (item.code) {
                obj[item.code] = item
            }
        })
        return obj
    }

    GetImage(code) {
        if(!code) return null
        if(!this.items || this.items.length==0) return null
        const pays = this.items.find(item => item.code === code)
        if (!pays) return null
        return pays.image || null
    }
}

export { Currency, CurrencyList }
